<template>
  <vue-scroll>
    <div class="page-contacts flex column scrollable only-y mb-20" id="page-contacts"
      v-show="userPermissionsFilter.preapprovetransactions" v-loading="pageLoading" :element-loading-text="loadingText"
      element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="page-TransactionAuthorization flex column mb-20">
        <div class="page-header">
          <h1 class="pageTitle">Transaction Authorization</h1>
          <h4>Authorize Transaction</h4>
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }"><i class="mdi mdi-home-outline"></i></el-breadcrumb-item>
            <el-breadcrumb-item>settings</el-breadcrumb-item>
            <el-breadcrumb-item>transactions</el-breadcrumb-item>
            <el-breadcrumb-item>transactionauthorization</el-breadcrumb-item>
          </el-breadcrumb>
        </div>

        <div class="mt-0 w-100">
          <div style="float: right">
            <el-button type="warning" icon="el-icon-tickets" @click="viewTransactions"></el-button>
          </div>
        </div>

        <table border="0" style="background-color:cornflowerblue;" cellspacing="0" cellpadding="20"
          class="full receipt-details">
          <tr>
            <td><b>Transaction Reference:</b> {{ transaction.referenceNumber }}</td>
            <td><b>Transaction Date:</b> {{ formatShortDate(transaction.createdOn) }}</td>
          </tr>
        </table>


        <table mc:repeatable="mainDisplay" width="100%" cellspacing="0" cellpadding="0" align="center" class="full">
          <tbody>
            <tr>
              <td align="center">

                <table width="100%" cellspacing="0" cellpadding="0" align="center" class="full table">
                  <tr>
                    <td>
                      <table width="100%" border="1" cellspacing="0" cellpadding="20" class="full receipt-details">
                        <tr>
                          <td colspan="2">
                            <h3>Sender Details</h3>
                          </td>
                        </tr>
                        <tr>
                          <td><strong>NAME:</strong></td>
                          <td>{{ transaction.firstName }} {{ transaction.middleName }} {{ transaction.lastName }}</td>
                        </tr>
                        <tr>
                          <td><strong>PHONE:</strong></td>
                          <td>{{ transaction.phoneNumber }}</td>
                        </tr>
                        <tr>
                          <td><strong>EMAIL:</strong></td>
                          <td>{{ transaction.email }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ transaction.documentTypeName }} Document:</strong></td>
                          <td>{{ transaction.documentNumber }}</td>
                        </tr>
                        <tr>
                          <td><strong>SENDER TYPE:</strong></td>
                          <td>{{ transaction.customerTypes }}</td>
                        </tr>
                        <tr>
                          <td><strong>AMOUNT:</strong></td>
                          <td>{{ transaction.senderCurrencySymbol }} {{ transaction.senderAmountStr }}</td>
                        </tr>
                        <tr>
                          <td><strong>TRANSACTION TYPE: </strong></td>
                          <td>{{ transaction.serviceName }}</td>
                        </tr>
                        <tr>
                          <td><strong>SOURCE OF FUNDS:</strong></td>
                          <td>{{ transaction.senderSourceOfFunds }}</td>
                        </tr>
                        <tr>
                          <td><strong>PURPOSE OF REMITTANCE:</strong></td>
                          <td>{{ transaction.senderPurposeOfRemittance }}</td>
                        </tr>
                      </table>
                    </td>
                    <td>
                      <table width="100%" border="1" cellspacing="0" cellpadding="20" class="full receipt-details">
                        <tr>
                          <td colspan="2">
                            <h3>Receiver Details</h3>
                          </td>
                        </tr>
                        <tr>
                          <td><strong>NAME:</strong></td>
                          <td>{{ transaction.receiverName }}</td>
                        </tr>
                        <!-- <tr>
                                                                                            <td><strong>GENDER:</strong></td>
                                                                                            <td>{{transaction.genderStr}}</td>
                                                                                        </tr> -->
                        <tr>
                          <td><strong>PHONE:</strong></td>
                          <td>{{ transaction.receiverPhoneNumber }}</td>
                        </tr>
                        <tr>
                          <td><strong>{{ transaction.receiverDocumentTypeName }} Document:</strong></td>
                          <td>{{ transaction.receiverDocumentNumber }}</td>
                        </tr>
                        <tr>
                          <td><strong>RECEIVER TYPE:</strong></td>
                          <td>{{ transaction.receiverCustomerTypes }}</td>
                        </tr>
                        <!-- <tr>
                                                                                            <td><strong>CITY:</strong></td>
                                                                                            <td>{{transaction.receiverCity}}</td>
                                                                                        </tr> -->
                        <tr>
                          <td><strong>ADDRESS:</strong></td>
                          <td>{{ transaction.receiverAddress }}</td>
                        </tr>
                        <tr>
                          <td><strong>COUNTRY:</strong></td>
                          <td>{{ transaction.receiverCountryName }}</td>
                        </tr>
                        <tr>
                          <td><strong>AMOUNT:</strong></td>
                          <td>{{ transaction.receiverCurrencySymbol }} {{ transaction.receiverAmountStr }}</td>
                        </tr>
                        <tr v-if="transaction.serviceTypeID === 1">
                          <td><strong>RECEIVER BANK:</strong></td>
                          <td>{{ transaction.receiverBankName }} - {{ transaction.receiverBankBranch }}</td>
                        </tr>
                        <tr v-if="transaction.serviceTypeID === 1">
                          <td><strong>ACCOUNT NAME:</strong></td>
                          <td>{{ transaction.receiverBankAccountName }}</td>
                        </tr>
                        <tr v-if="transaction.serviceTypeID === 1">
                          <td><strong>
                              <span v-if="transaction.receiverCountryID == 13 || transaction.receiverCountryID == 74"
                                class="input__label-content">IBAN NUMBER</span>
                              <span v-if="transaction.receiverCountryID == 82 || transaction.receiverCountryID == 136"
                                class="input__label-content">ROUTING NUMBER</span>
                              <span v-if="transaction.receiverCountryID == 142" class="input__label-content">CARD
                                NUMBER</span>
                              <span
                                v-if="transaction.receiverCountryID != 13 && transaction.receiverCountryID != 74 && transaction.receiverCountryID != 142 && transaction.receiverCountryID != 82 && transaction.receiverCountryID != 136">ACCOUNT
                                NUMBER</span>:</strong></td>
                          <td>{{ transaction.receiverBankAccountNumber }}</td>
                        </tr>
                        <tr v-if="transaction.serviceTypeID === 2">
                          <td><strong>PickUp Location:</strong></td>
                          <td>{{ transaction.receiverCity }} - {{ transaction.receiverAddress }}</td>
                        </tr>
                        <tr v-if="transaction.serviceTypeID === 3">
                          <td><strong>Mobile Money No:</strong></td>
                          <td>{{ transaction.receiverMobileNumber }}</td>
                        </tr>

                      </table>
                    </td>
                    <td>
                      <table width="100%" border="1" cellspacing="0" cellpadding="20" class="full receipt-details">
                        <tr>
                          <td colspan="2">
                            <h3>Transaction Details</h3>
                          </td>
                        </tr>
                        <tr>
                          <td><strong>SENDING AMOUNT:</strong></td>
                          <td>{{ transaction.senderCurrencySymbol }} {{ transaction.senderAmount }}</td>
                        </tr>
                        <tr>
                          <td><strong>EXCHANGE RATE: </strong></td>
                          <td> {{ transaction.exchangeRate }}</td>
                        </tr>
                        <tr>
                          <td><strong>FEES:</strong></td>
                          <td>{{ transaction.senderCurrencySymbol }} {{ transaction.tariffFee }}</td>
                        </tr>
                        <tr>
                          <td><strong>EXCISE DUTY:</strong></td>
                          <td>({{ transaction.taxPercentage }}%): {{ transaction.exciseDutyAmount }}</td>
                        </tr>
                        <tr>
                          <td><strong>AMOUNT TO PAY:</strong></td>
                          <td>{{ transaction.senderCurrencySymbol }} {{ transaction.senderAmountStr }}</td>
                        </tr>
                        <tr>
                          <td><strong>TENTATIVE RECEIVING AMOUNT:</strong></td>
                          <td>{{ transaction.receiverCurrencySymbol }} {{ transaction.receiverAmountStr }}</td>
                        </tr>
                        <tr>
                          <td><strong>RATE AS ON:</strong></td>
                          <td>{{ currentDate() }}</td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </tbody>
        </table>

        <!--<table border="0" cellspacing="0" cellpadding="20" class="full receipt-details">
          <tr>
            <td><b>Transaction Reference:</b> {{transaction.referenceNumber}}</td>
            <td><b>Transaction Date:</b> {{formatShortDate(transaction.createdOn)}}</td>
          </tr>
          <tr>
              <td><b>Sender Name:</b> {{transaction.senderName}}</td>
              <td><b>Receiver Name:</b> {{transaction.receiverFirstName}} {{transaction.receiverMiddleName}} {{transaction.receiverLastName}}</td>
          </tr>
          <tr>
              <td><b>Sender Amount:</b> {{transaction.senderCurrencySymbol}} {{transaction.senderAmount}}</td>
              <td><b>Receiver Amount:</b> {{transaction.receiverCurrencySymbol}} {{transaction.receiverAmount}}</td>
          </tr>
        </table>
        -->

        <div class="mt-10" v-show="userPermissionsFilter.approvetransactions">
          <el-row :gutter="20">
            <el-col :span="8">
              <span>Authorization Status</span><span :class="required"> *</span>
              <el-select v-model="tariff.isApproved" filterable placeholder="Select Authorization Status" class="mb-10"
                style="width: 100%" name="authorizationStatus" v-validate="'required'" data-vv-as="Authorization Status">
                <el-option v-for="authorizationStatus in authorizationStatuses" :key="authorizationStatus.id"
                  :label="authorizationStatus.name" :value="authorizationStatus.id">
                </el-option>
              </el-select>
              <transition name="fade">
                <span class="danger-text">{{
                  errors.first("authorizationStatus")
                }}</span>
              </transition>
            </el-col>
            <el-col :span="8">
              <span>Remarks</span><span :class="required"> *</span>
              <el-input placeholder="Remarks" v-model="tariff.remarks" name="remarks" v-validate="'required'"
                data-vv-as="Remarks" type="textarea"></el-input>
              <transition name="fade">
                <span class="danger-text">{{ errors.first("remarks") }}</span>
              </transition>
            </el-col>
            <el-col :span="3"><span :class="required"><br></span><el-button type="primary" @click="requestAuthCode"
                class="el-button--success"><i></i> Request Code</el-button></el-col>

            <el-col :span="4">
              <span>Auth Code</span><span :class="required"> *</span>
              <el-input placeholder="Auth Code" v-model="tariff.token" name="token" v-validate="'required'"
                data-vv-as="Authorization Code" type="text"></el-input>
              <transition name="fade">
                <span class="danger-text">{{ errors.first("token") }}</span>
              </transition>
            </el-col>
          </el-row>
          <div class="mt-10">
            <el-button type="primary" @click="checkValidAndSubmit"><i></i> Submit</el-button>
            <el-button type="info" @click="clearState"><i></i> Reset</el-button>
          </div>
          <div class="col-12 col-sm-12 row avatar align-vertical">
            <span v-if="TransactionDoc !== ''" style="margin: 20px 0px;">
              <img style="width:100%;height:100%" id="TransactionDocument" v-bind:src="TransactionDoc"
                class="align-vertical-middle" />
            </span>
            <span style="margin: 20px 0px;" v-else>No Supporting Document</span>
          </div>
        </div>
      </div>
    </div>
  </vue-scroll>
</template>


<script>
import PermissionsMixin from '@/mixins/PermissionsMixins'
import ApiServiceMixin from "@/mixins/ApiServiceMixin";
import MessagesMixin from "@/mixins/MessagesMixins";
import UtilitiesMixin from "@/mixins/UtilitiesMixin";
import router from "@/router/";
import { bus } from "@/main";
import { Validator } from "vee-validate";

export default {
  name: "TransactionAuthorization",
  data() {
    return {
      tarifftypes: ["Fixed", "Percentage"],
      transaction: {},
      TransactionDoc: '',
      tariff: {
        id: 0,
        fromCountryID: "",
        toCountryID: "",
        serviceTypeID: "",
        fromAmount: "",
        transactionId: router.currentRoute.params.id,
        toAmount: "",
        tranctionFeeTypeStr: "",
        amount: "",
        isApproved: false,
        remarks: "",
        token: "",
        notificationActive: false,
        timespan: 0,
        timeSpanType: "",
        notificationPhoneNumbers: "",
        notificationEmails: "",
      },
      authorizationStatuses: [
        { id: true, name: "Approved" },
        { id: false, name: "Rejected" },
      ],
    };
  },
  methods: {
    viewTransactions() {
      router.push("/approveBackofficeTransaction");
    },
    currentDate() {
      const current = new Date();
      const date = `${("0" + (current.getDate())).slice(-2)}-${("0" + (current.getMonth() + 1)).slice(-2)}-${current.getFullYear()}`;
      return date;
    },
    clearState() {
      this.tariff = {
        id: 0,
        fromCountryID: "",
        toCountryID: "",
        serviceTypeID: "",
        fromAmount: "",
        toAmount: "",
        tranctionFeeTypeStr: "",
        amount: "",
        token: "",
        notificationActive: false,
        timespan: 0,
        timeSpanType: "",
        notificationPhoneNumbers: "",
        notificationEmails: "",
      };
      this.$validator.reset();
    },
    requestAuthCode() {
      this.startLoader("Requesting for Code ...");
      this.sendAuthorizationCode(this.tariff)
        .then((result) => {
          this.stopLoader();
          self.tariff = result;
          if (result.item1 == true) {
            this.successMessage("Code was was sent successfully.");
          }
          else {
            this.errorMessage("ERROR: " + result.item2);
          }
        })
        .catch((err) => {
          this.stopLoader();
          console.log(err);
          this.errorMessage("Error Sending Code.");
        });;
    },
    checkValidAndSubmit() {
      this.startLoader("Authorizing Transaction ...");
      let self = this;
      console.log(self.tariff);
      this.$validator
        .validateAll()
        .then((result) => {
          if (result) {
            this.authorizeTransactions(self.tariff)
              .then((result) => {
                self.stopLoader();
                if (result.item1 == true) {
                  self.tariff = result;
                  self.clearState();
                  this.successMessage(
                    "Transaction was authorized successfully."
                  );
                  router.push("/transactions");
                } else {
                  this.errorMessage(
                    "Error! " + result.item2
                  );
                }
              })
              .catch((err) => {
                this.stopLoader();
                console.log(err);
                this.errorMessage("An Error occured.");
              });
          }
        })
        .catch((err) => console.log(err));
    },
    setCurrent() {
      var id = router.currentRoute.params.id;

      this.pageTitle = "AddAuthorize Transaction";
      this.pageSubtitle = "AddAuthorize Transaction";

      if (id) {
        this.findTransactionByID(id).then(result => {
          this.transaction = result;
          this.getTransactionDocument(id).then(result => {
            if (result.code == "200") {
              this.TransactionDoc = "data:image/jpeg;base64," + result.message;
            }
            this.stopLoader();
          }).catch((err) => {
            this.stopLoader();
            console.log(err);
            this.errorMessage("Transaction supporting document was not found.");
          });
        });
      }
    },
  },
  created() {
    this.getCountries();
    this.getServices();

    this.setCurrent();
  },
  mixins: [ApiServiceMixin, MessagesMixin, UtilitiesMixin, PermissionsMixin],
};
</script>

<style>
table tr td {
  vertical-align: top;
  border: 0px;
  outline: none;
}

h3 {
  margin: 0;
  font-weight: 900;
}

.receipt-details {
  border: 0px;
  outline: none;
}

.receipt-details tr td {
  padding: 5px 10px;
  font-size: 13px;
}

.receipt-details tr td strong {
  font-size: 15px;
}
</style>